// @flow
import Pincode from '../../models/pincode';
import MobileNumber from '../../models/mobileNumber';
import PanNumber from '../../models/panNumber';
import GstIn from '../../models/gstIn';
import { makeApiCall } from '../apiService/apiService';
import { isValidJson } from '../helpers';

export const initAppActions = {
  SET_PROTOS: 'SET_PROTOS',
  GET_LOCATIONS: 'GET_LOCATIONS',
  GET_SHOPFLOOR_ZONE_TYPES: 'GET_SHOPFLOOR_ZONE_TYPE',
  GET_REASONS: 'GET_REASONS',
  SET_ROUTE_SPECIFIC_FLAGS: 'SET_ROUTE_SPECIFIC_FLAGS',
  GET_DIRECT_DELIVERY_COUNT: 'GET_DIRECT_DELIVERY_COUNT'
};

export const setProtoAction = (obj: Object) => ({
  type: initAppActions.SET_PROTOS,
  payload: obj
});

export const getReasonsAction = (obj: Object) => ({
  type: initAppActions.GET_REASONS,
  payload: obj
});

export const getDirectDeliveryCountAction = (obj: Object) => ({
  type: initAppActions.GET_DIRECT_DELIVERY_COUNT,
  payload: obj
});
export const getLocationsAction = (obj: Object) => ({
  type: initAppActions.GET_LOCATIONS,
  payload: obj
});

export const getShopfloorZoneTypeAction = (obj: Object) => ({
  type: initAppActions.GET_SHOPFLOOR_ZONE_TYPES,
  payload: obj
});

export const setRouteSpecificFlags = (matchedLocation: Object) => ({
  type: initAppActions.SET_ROUTE_SPECIFIC_FLAGS,
  payload: {
    search: matchedLocation.search,
    pathname: matchedLocation.pathname
  }
});

export const getDirectDeliveryCount = () => (dispatch: Function) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDirectDeliveryCount',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDirectDeliveryCountAction({
            directDeliveryCount: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDirectDeliveryCountAction({
            directDeliveryCount: null
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        getDirectDeliveryCountAction({
          directDeliveryCount: null
        })
      );
    },
    catchCb: () => {
      dispatch(
        getDirectDeliveryCountAction({
          directDeliveryCount: null
        })
      );
    },
    notShowPopupOnError: true
  };

  return makeApiCall(requestObj);
};
export const getLocations = () => (dispatch: Function) => {
  const sessionLocationListParsed = isValidJson(
    sessionStorage.getItem('locationList')
  );
  if (sessionLocationListParsed instanceof Array) {
    dispatch(
      getLocationsAction({
        fetchingLocations: false,
        locationList: sessionLocationListParsed
      })
    );
    return ''; // Just returning an empty string for consistent return
  }
  dispatch(
    getLocationsAction({
      fetchingLocations: true,
      locationList: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getLocations',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        // eslint-disable-next-line no-console
        console.log('getLocations call 200 success');
        dispatch(
          getLocationsAction({
            fetchingLocations: false,
            locationList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getLocations call 200 failure');
        dispatch(
          getLocationsAction({
            fetchingLocations: false,
            locationList: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getLocations call failed ', res);
      dispatch(
        getLocationsAction({
          fetchingLocations: false,
          locationList: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getLocations call', res);
      dispatch(
        getLocationsAction({
          fetchingLocations: false,
          locationList: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getShopfloorZoneTypes = () => (dispatch: Function) => {
  const sessionLocationListParsed = isValidJson(
    sessionStorage.getItem('zoneTypeList')
  );
  if (sessionLocationListParsed instanceof Array) {
    dispatch(
      getShopfloorZoneTypeAction({
        fetchingLocations: false,
        zoneTypeList: sessionLocationListParsed
      })
    );
    return ''; // Just returning an empty string for consistent return
  }
  dispatch(
    getShopfloorZoneTypeAction({
      fetchingZoneTypes: true,
      zoneTypeList: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getAllZoneTypes',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        // eslint-disable-next-line no-console
        console.log('getShopfloorZoneType call 200 success');
        dispatch(
          getShopfloorZoneTypeAction({
            fetchingZoneTypes: false,
            zoneTypeList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getShopfloorZoneType call 200 failure');
        dispatch(
          getShopfloorZoneTypeAction({
            fetchingZoneTypes: false,
            zoneTypeList: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getShopfloorZoneType call failed ', res);
      dispatch(
        getShopfloorZoneTypeAction({
          fetchingZoneTypes: false,
          zoneTypeList: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getShopfloorZoneType call', res);
      dispatch(
        getShopfloorZoneTypeAction({
          fetchingZoneTypes: false,
          zoneTypeList: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const initCalls = () => (dispatch: Function) => {
  const pincode = new Pincode();
  const pincodeproto = Object.getPrototypeOf(pincode);
  const mobileNumber = new MobileNumber();
  const mobileNumberproto = Object.getPrototypeOf(mobileNumber);
  const panNumber = new PanNumber();
  const panNumberproto = Object.getPrototypeOf(panNumber);
  const gstIn = new GstIn();
  const gstInproto = Object.getPrototypeOf(gstIn);
  dispatch(
    setProtoAction({
      pincode,
      pincodeproto,
      mobileNumber,
      mobileNumberproto,
      panNumber,
      panNumberproto,
      gstIn,
      gstInproto
    })
  );

  // Soon we'll add client call, location call here.
};

const FailurePayload = dispatch => {
  dispatch(
    getReasonsAction({
      fetchingReasons: false,
      reasonList: []
    })
  );
};

export const getReasons = (reasonType: string = 'manual') => (
  dispatch: Function
) => {
  const cacheKey = reasonType === 'CLAIM' ? 'claimReasonList' : 'reasonList';
  const sessionLocationListParsed = isValidJson(
    sessionStorage.getItem(cacheKey)
  );
  if (sessionLocationListParsed instanceof Array) {
    dispatch(
      getReasonsAction({
        fetchingReasons: false,
        reasonList: sessionLocationListParsed
      })
    );
    return ''; // Just returning an empty string for consistent return
  }
  dispatch(
    getReasonsAction({
      fetchingReasons: true,
      reasonList: []
    })
  );

  const isClaim = reasonType === 'CLAIM';
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isClaim ? 'getRejectionReasons' : 'getReasons',
    replaceParamsArr: isClaim ? [{ key: 'reasonType', val: 'CLAIM' }] : null,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        // eslint-disable-next-line no-console
        console.log('getReasons call 200 success');
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify(res.payload));
        } catch (e) {
          console.log('Could not save reasons list in session storage');
        }
        dispatch(
          getReasonsAction({
            fetchingReasons: false,
            reasonList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getReasons call 200 failure');
        dispatch(
          getReasonsAction({
            fetchingReasons: false,
            reasonList: []
          })
        );
      }
    },
    failureCb: () => {
      FailurePayload(dispatch);
    },
    catchCb: () => {
      FailurePayload(dispatch);
    }
  };

  return makeApiCall(requestObj);
};
